export default __webpack_public_path__ + "static/humane-technology-d6f17171e5b13e4b3b026c28813c0278.svg";